import script from "./yhqInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./yhqInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./yhqInfoAdd.vue?vue&type=style&index=0&id=c9083cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9083cc6"]])

export default __exports__